import { Nullable } from "../../../Types/Common";
import {
  IPettyCashAccountZoneDashboardServiceResponse,
  IPettyCashCategoryServiceResponse,
  IPettyCashExpenseListServiceResponse,
} from "../../../Types/PettyCash";
import { IBaseResponse } from "../../../Types/UserProfileDetails";
import ApiService from "../../ApiService";

enum PettyCashEndpoints {
  CATEGORIES = "/employee/expense/categories",
  EXPENSE_FORM = "/employee/expense/apply",
  EXPENSE_LIST = "/employee/expense/list",
  ACCOUNT_ZONE = "/account-zone/expense-dashboard",
  ADD_BALANCE = "/account-zone/add-balance",
  EXPENSE_DELETE = "/expense-delete",
}

class PettyCash extends ApiService {
  async pettyCashExpenseCategories() {
    return this.get<IPettyCashCategoryServiceResponse>(
      PettyCashEndpoints.CATEGORIES
    );
  }

  async submitPettyCashExpenseForm(pettyCashFormData: FormData) {
    return this.post<any>(PettyCashEndpoints.EXPENSE_FORM, pettyCashFormData);
  }

  async pettyCashExpenseList(pettyCashExpenseParams: {
    center_id: number;
    month: string;
  }) {
    return this.post<IPettyCashExpenseListServiceResponse>(
      PettyCashEndpoints.EXPENSE_LIST,
      pettyCashExpenseParams
    );
  }

  async deletePettyCashExpense(deletePettyCashExpenseParams: { id: number }) {
    return this.delete<IBaseResponse>(
      PettyCashEndpoints.EXPENSE_DELETE,
      deletePettyCashExpenseParams
    );
  }

  async pettyCashDashboardAccountZone(pettyCashAccountZoneParams: {
    active_year: number;
  }): Promise<IPettyCashAccountZoneDashboardServiceResponse> {
    return this.post<IPettyCashAccountZoneDashboardServiceResponse>(
      PettyCashEndpoints.ACCOUNT_ZONE,
      pettyCashAccountZoneParams
    );
  }

  async pettyCashAddBalanceAccountZone(addBalanceParams: {
    center_id: number;
    user_id: number;
    balance: number;
    date?: string;
  }): Promise<IBaseResponse> {
    return this.post<IBaseResponse>(
      PettyCashEndpoints.ADD_BALANCE,
      addBalanceParams
    );
  }
}

export const pettyCashService = new PettyCash();
